import React from "react";
import { Text } from "@chakra-ui/react";
import { useTranslation } from "react-i18next";

import { AuthentificationBox } from "modules/authentication/components/AuthentificationBox";
import { ResetCredentialsEmailStepForm } from "modules/authentication/components/ResetCredentialsEmailStepForm/ResetCredentialsEmailStepForm";

export const ResetCredentialsEmailStep = () => {
  const { t } = useTranslation();

  return (
    <AuthentificationBox>
      <Text mt={5} textStyle="subtitle">
        {t("login.reset.title")}
      </Text>
      <ResetCredentialsEmailStepForm />
    </AuthentificationBox>
  );
};
